import React, { useEffect } from "react";
import "./CreditPrintReport.css";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Spin } from "antd";
import { useLocation } from "react-router-dom";
import numeral from "numeral";
import { getCreditPrintReport } from "../../redux/actions/creditPrintReport.action";
import CreditPrintReportHeader from "./CreditPrintReportHeader/CreditPrintReportHeader";
import { currencySymbol } from "../../utils/constants";
import Loader from "react-loader-spinner";

const CreditPrintReport = () => {
  const dispatch = useDispatch();
  const token = ReadCookie("token");
  const { creditPrintReport } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  let return_header_id = query.get("return_header_id");

  const data = creditPrintReport && creditPrintReport?.payload?.data;

  const values = {
    return_header_id: return_header_id,
  };

  useEffect(() => {
    dispatch(getCreditPrintReport(token, values));
  }, []);

  const handlePrint = () => {
    const css = '@page { size: portrait; margin: 2mm 10mm !important; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  let sumAmount = creditPrintReport?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.gross_amount));
  },
    0);

  let total = creditPrintReport?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.net_amount));
  },
    0);

  let tax = creditPrintReport?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.tax_amount));
  },
    0);


  if (creditPrintReport?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  return (
    <div className="__credit_print_report"    >
      <table width="100%">
        <thead>
          <tr>
            <td>
              <CreditPrintReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body data={data} sumAmount={sumAmount} tax={tax} total={total} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CreditPrintReport;

const Body = ({ data, sumAmount, tax, total }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          <table width="100%">
            <tbody>
              <tr>
                <th
                  style={{
                    width: "88px",
                  }}
                >
                  Quantity
                </th>
                <th
                  className="__item_ss"
                >
                  Item
                </th>
                <th
                  style={{
                    width: "50%",
                  }}
                >
                  Description
                </th>
                <th
                  style={{
                    width: "110px",
                    whiteSpace: 'nowrap',
                    textAlign: 'right'
                  }}
                >
                  Tax Percent
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right'
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    width: "110px",
                    textAlign: 'right'
                  }}
                >
                  Amount
                </th>
              </tr>
              {data?.map((it, index) => {
                return (
                  <tr key={index}>
                    <td>{numeral(it.quantity).format("0")}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {it.sku}
                    </td>
                    <td>
                      {it?.description && it?.description}
                    </td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>
                      {it.tax_percent && it.tax_percent}%
                    </td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>{currencySymbol}{it.rate && it.rate}</td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>{currencySymbol}{it.gross_amount && Number(it.gross_amount).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <hr />
      <div className="__summary_box">
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td style={{ width: '270px' }}>
                <table width="100%" className="__summary_box_table">
                  <tbody>
                    <tr>
                      <td>
                        Total
                      </td>
                      <td></td>
                      <td>
                        {currencySymbol}{sumAmount && numeral(sumAmount).format("00.00")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Add Tax
                      </td>
                      <td></td>
                      <td>{currencySymbol}{tax && numeral(tax).format("00.00")}</td>
                    </tr>
                    <tr>
                      <td>
                        Net Total
                      </td>
                      <td></td>
                      <td>{currencySymbol}{total && numeral(total).format("00.00")}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}